An array of physical addresses for the person.

The physical addresses are ordered in descending preference.

This field is redacted and an empty array is returned when a candidate or job application is deleted.
